import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS } from "@/data/content";
import { Reveal, Overline } from "./Reveal";

export const Faq = () => {
  return (
    <section id="faq" data-testid="faq-section" className="relative py-24 md:py-32">
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <Reveal>
          <Overline index="04">Questions</Overline>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="font-serif text-3xl md:text-5xl tracking-tight text-white leading-[1.1] mb-12">
            Everything you might ask.
          </h2>
        </Reveal>

        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b border-white/10"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="text-left font-serif text-xl md:text-2xl text-white hover:no-underline hover:text-gold py-6">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-vmuted text-[15px] leading-relaxed pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};
